import { render, staticRenderFns } from "./visitorAction.vue?vue&type=template&id=643cb106&scoped=true"
import script from "./visitorAction.vue?vue&type=script&lang=js"
export * from "./visitorAction.vue?vue&type=script&lang=js"
import style0 from "./visitorAction.vue?vue&type=style&index=0&id=643cb106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643cb106",
  null
  
)

export default component.exports